import { Typography } from '@mui/material'
import { InsightItem } from 'components/core/insights'
import { GlobalOutcome, Outcome } from 'pbts/c1/api/analysis/v1/analysis'
import { InsightType } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export type GrantsGlobalLabelProps = {
    outcome: Outcome | undefined
}

export const GrantsGlobalLabel: FC<GrantsGlobalLabelProps> = ({ outcome }) => {
    if (!outcome) {
        return null
    }
    const grantsGlobal = outcome.outcome as unknown as GlobalOutcome
    return (
        <Typography>
            <FormattedMessage
                id="analysis_insights_grants_global"
                defaultMessage="{pop_with_access} out of {num_in_pop} users in your organization have this entitlement"
                values={{
                    pop_with_access: grantsGlobal.popWithAccess,
                    num_in_pop: grantsGlobal.numInPop,
                }}
            />
        </Typography>
    )
}

export type GrantsGlobalProps = {
    outcome: Outcome | undefined
    insightType: InsightType
    showIcon?: boolean
}

export const GrantsGlobal: FC<GrantsGlobalProps> = ({ outcome, insightType, showIcon = true }) => {
    if (!outcome) {
        return null
    }
    if (!showIcon) {
        return <GrantsGlobalLabel outcome={outcome} />
    }
    return (
        <InsightItem key="grants_account_item" insightType={insightType}>
            <GrantsGlobalLabel outcome={outcome} />
        </InsightItem>

    )
}
